<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
	components: {
		LazyHydrate,
	},
	props: {
		items: Array,
	},
	computed: {
		cItems() {
			return this.items?.filter((item) => this.urlMatch(item)) || []
		},
	},
	methods: {
		urlMatch(config) {
			const currentRoute = this.$route.fullPath
			const fns = {
				exact: (pattern) => currentRoute === pattern,
				pattern: (pattern) => currentRoute.startsWith(pattern),
				regex: (pattern) => new RegExp(pattern).test(currentRoute),
			}
			let someFn = (condition) => fns[condition.urlCondition]?.(condition.pattern)

			if (config.urlHidePatterns?.some(someFn)) return false
			if (config.showAll) return true
			return !!config.urlShowPatterns?.some(someFn)
		},
	},
}
</script>
<template>
	<LazyHydrate v-if="cItems.length" when-visible>
		<DynamicPageItems :items="cItems" />
	</LazyHydrate>
</template>

